import { render, staticRenderFns } from "./AutoBidList.vue?vue&type=template&id=45854abc&scoped=true&"
import script from "./AutoBidList.vue?vue&type=script&lang=js&"
export * from "./AutoBidList.vue?vue&type=script&lang=js&"
import style0 from "./AutoBidList.vue?vue&type=style&index=0&id=45854abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45854abc",
  null
  
)

export default component.exports